import { InviteToRqModalStep } from '@/components/modals/InviteToRqModal/types'
import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  hideInviteToRqModal,
  selectInviteToRqModalEmails,
  selectInviteToRqModalStep,
  selectIsShowingInviteToRqModal,
  setInviteToRqModalStep,
  showInviteToRqModal,
} from '@/redux/slices/inviteToRqModal'

/**
 * The invite-to-RQ modal, wherever it's opened from.
 *
 * State lives in the store rather than the URL: as a search param, the modal
 * added a history entry, so going back to the previous page reopened it there.
 */
export function useInviteToRqModal() {
  const dispatch = useAppDispatch()

  const isShowing = useAppSelector(selectIsShowingInviteToRqModal)
  const step = useAppSelector(selectInviteToRqModalStep)
  const emails = useAppSelector(selectInviteToRqModalEmails)

  function showModal(step?: InviteToRqModalStep, emails: string[] = []) {
    dispatch(showInviteToRqModal({ step, emails }))
  }

  function setStep(step: InviteToRqModalStep) {
    dispatch(setInviteToRqModalStep(step))
  }

  function hideModal() {
    dispatch(hideInviteToRqModal())
  }

  return {
    isShowing,
    show: showModal,
    hide: hideModal,
    step,
    setStep,
    emails,
  }
}
